import { gql } from "@apollo/client";

const GET_PUBLIC_CMS = gql`
  query getPublicCMS($input: GetCMS!) {
    getPublicCMS(input: $input) {
      status
      error
      data {
        commonContent
        pageContent
      }
    }
  }
`;

export default GET_PUBLIC_CMS;
